<div class="page">
  <div class="header" *ngIf="fileName">{{ fileName }}</div>
  <div #viewer class="viewer"></div>
</div>
